import { Component, HostBinding, inject, input, output } from '@angular/core';
import { QaiButtonComponent } from '@qai/ui';
import { TranslocoModule } from '@jsverse/transloco';
import { NativeCallService } from 'src/app/services/native-call.service';

@Component({
  imports: [QaiButtonComponent, TranslocoModule],
  selector: 'app-screenshare-button',
  standalone: true,
  styleUrls: ['./screenshare-button.css'],
  templateUrl: './screenshare-button.html',
})
export class ScreenshareButtonComponent {
  private readonly nativeCallService = inject(NativeCallService);

  @HostBinding('class.native-ios')
  protected get isNativeIos() {
    return this.nativeCallService.isNativeIos;
  }

  isScreenSharing = input(false);
  disabled = input(false);

  readonly clicked = output<void>();

  protected handleClick() {
    this.clicked.emit();
  }
}
